<template>
    <div class="contact-wrap">
        <!-- 联系我们 -->
        <div class="ways">
            <p class="title">{{$t('contact.contact')}}</p>
            <div class="content">
                <div class="ways-1">
                    <div class="way-img-1"></div>
                    <div>
                        <label>{{$t('contact.addBJ')}}</label>
                        <span>0512-67990267</span>
                    </div>
                </div>
                <div class="ways-2">
                    <div class="way-img-2"></div>
                    <div>
                        <label>{{$t('contact.welcome')}}</label>
                        <span>CSC@clinicalservice.cn</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 区域办公室 -->
        <KllkMap></KllkMap>
        <!-- 合作表单 -->
        <!-- <KllkForm></KllkForm> -->
    </div>
</template>
<script>
    // 组件
    import KllkForm from "../../components/kllk-form-warp";
    import KllkMap from "../contact/components/map";

    export default {
        components: {
            KllkForm,
            KllkMap,
        }
    };
</script>
<style lang="less" scoped>
    @import "../../style/constant";

    .contact-wrap {
        background-color: #ffffff;
        padding-top: 100px;

        .ways {
            max-width: @page-width;
            margin: 0 auto;

            .title {
                text-align: center;
                color: @active-color;
                font-size: 16pt;
                margin-bottom: 60px;
                font-weight: bold;
            }
        }

        .ways {
            .content {
                display: flex;

                .ways-1,
                .ways-2 {
                    height: 165px;
                    display: flex;
                    align-items: center;
                    flex: 1;
                    box-shadow: 0 5px 30px 0 rgba(77, 138, 221, 0.15);
                    margin:20px;
                }

                .way-img-1, .way-img-2 {
                    width: 190px;
                    height: 100%;
                }

                .way-img-1 {
                    background: url("../../../src/assets/phone.png") center center no-repeat;
                    background-size: 50%;
                }

                .way-img-2 {
                    background: url("../../../src/assets/email.png") center center no-repeat;
                    background-size: 50%;
                }

                label,
                span {
                    display: block;
                    text-align: left;
                }

                label {
                    opacity: 0.5;
                    font-size: 16px;
                    color: @title-color;
                    width: 100%;
                    margin-bottom: 10px;
                }

                span {
                    font-size: 28px;
                    color: @title-color;
                    display: block;
                    cursor: pointer;
                    word-break: break-all
                }
            }
        }
    }

    @media screen and (max-width: 996px) {
        .ways {
            .content {
                flex-direction: column;
                padding: 0 20px;
            }

            .way-img-1, .way-img-2 {
                min-width: 96px;
                max-width: 96px;
            }
        }
    }
</style>
